import { FC, useMemo } from "react";

import { CheckBadgeIcon } from "@heroicons/react/24/outline";
import { UserPermission } from "_graphql/cache/auth";
import { User_role_user_role } from "_graphql/queries/kek/__generated__/User_role";
import _ from "lodash";
import { applicationFeatures } from "_graphql/data/features";
import { filterListByCurrentDomain } from "utils";
import lodash from "lodash";

type Props = {
  userRole: User_role_user_role | null | undefined;
};

const UserRoleView: FC<Props> = ({ userRole }) => {
  const permissions = useMemo(() => {
    try {
      return JSON.parse(atob(userRole?.privileges || "")) || [];
    } catch (e) {
      console.error("Failed to parse privileges:", e);
      return [];
    }
  }, [userRole]);

  // Filter application features to only show those where the user has at least one permission.
  const filteredApplicationFeatures = useMemo(() => {
    return filterListByCurrentDomain(applicationFeatures).filter(
      (application) =>
        _.some(application.permissions, (permission) =>
          permissions.includes(permission.value as UserPermission)
        )
    );
  }, [permissions]);

  return (
    <div className="space-y-6 divide-y divide-gray-200">
      <div>
        <span className="text-xs font-light">Role Information</span>
        <div className="grid grid-cols-3 gap-6 mt-2">
          <div className="">
            <span className="block text-sm font-light text-gray-700">Name</span>
            <div className="mt-1 block w-full sm:text-sm">
              {userRole?.position || "N/A"}
            </div>
          </div>
        </div>
      </div>
      <div className="pt-6">
        <span className="text-xs font-light">Permissions Information</span>
        <div className="space-y-6 mt-2">
          {filteredApplicationFeatures.length > 0 ? (
            _.map(filteredApplicationFeatures, (application, idx) => {
              const id = `applications.${application.name}`;
              return (
                <div key={idx} className="pt-6 first:pt-0">
                  <div className="space-y-6 mt-2">
                    <div className="col-span-3">
                      <div>
                        <div className="flex justify-between">
                          <span className="flex flex-grow flex-col">
                            <span className="text-sm font-medium text-gray-900">
                              Gets Access to {application?.name}
                            </span>
                            {/* <span className='text-sm text-gray-500 mt-1'>
                                {application?.description}
                              </span> */}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="space-y-6 mt-2">
                    <div className="border border-gray-300 bg-gray-50 grid grid-cols-3 gap-6 p-6 rounded">
                      {/* Fixed bug: Map directly over application.permissions */}
                      {_.map(
                        application.permissions.filter((permission) =>
                          permissions.includes(
                            permission.value as UserPermission
                          )
                        ),
                        (permission) => (
                          <div key={permission.value} className="">
                            <div className="mt-1 w-full space-y-1">
                              <div className="relative flex items-start">
                                <div className="flex h-6 items-center">
                                  <CheckBadgeIcon className="size-6 text-blue-700" />
                                </div>
                                <div className="ml-3 text-sm leading-6">
                                  {/* Corrected htmlFor and label text */}
                                  <label
                                    htmlFor={`${permission?.value}.permissions`}
                                    className="font-medium text-gray-900"
                                  >
                                    {permission.name}
                                  </label>
                                  <p
                                    id={`${permission.value}-description`}
                                    className="text-gray-500"
                                  >
                                    {permission.description}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        )
                      )}
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="text-center text-gray-500 py-4">
              <p>This role has no assigned permissions.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserRoleView;
